module.exports = __webpack_public_path__ + "static/media/b4-black-english.f1e7924e.png";